var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxChecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.538 6h24.924A5.538 5.538 0 0142 11.538v24.924A5.538 5.538 0 0136.462 42H11.538A5.538 5.538 0 016 36.462V11.538A5.538 5.538 0 0111.538 6zm21.764 10.384a1.053 1.053 0 00-1.444-.006l-11.71 11.11-4.03-3.753a1.055 1.055 0 00-1.446.023l-1.037 1.03a.97.97 0 00.013 1.397l5.702 5.432c.4.381 1.052.38 1.449.005l13.554-12.85a.945.945 0 00.002-1.379l-1.053-1.009z",
    id: "checkbox-checked_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "checkbox-checked_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#checkbox-checked_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#checkbox-checked_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#checkbox-checked_svg__b)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggZD0iTTExLjUzOCA2aDI0LjkyNEE1LjUzOCA1LjUzOCAwIDAgMSA0MiAxMS41Mzh2MjQuOTI0QTUuNTM4IDUuNTM4IDAgMCAxIDM2LjQ2MiA0MkgxMS41MzhBNS41MzggNS41MzggMCAwIDEgNiAzNi40NjJWMTEuNTM4QTUuNTM4IDUuNTM4IDAgMCAxIDExLjUzOCA2em0yMS43NjQgMTAuMzg0YTEuMDUzIDEuMDUzIDAgMCAwLTEuNDQ0LS4wMDZsLTExLjcxIDExLjExLTQuMDMtMy43NTNhMS4wNTUgMS4wNTUgMCAwIDAtMS40NDYuMDIzbC0xLjAzNyAxLjAzYS45Ny45NyAwIDAgMCAuMDEzIDEuMzk3bDUuNzAyIDUuNDMyYy40LjM4MSAxLjA1Mi4zOCAxLjQ0OS4wMDVsMTMuNTU0LTEyLjg1YS45NDUuOTQ1IDAgMCAwIC4wMDItMS4zNzlsLTEuMDUzLTEuMDA5eiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48dXNlIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjYSIvPjxnIG1hc2s9InVybCgjYikiIGZpbGw9ImN1cnJlbnRDb2xvciI+PHBhdGggZD0iTTAgMGg0OHY0OEgweiIvPjwvZz48L2c+PC9zdmc+";
export { SvgCheckboxChecked as ReactComponent };